/* Auto-generated, do not edit */
import React from 'react';

interface Props {
  size?: number | string;
  width?: number | string;
  height?: number | string;
  fill?: string;
}

function Avatar_icn_avatar8(props: Props) {
    const { size = 14, width = size, height = size, fill = '' } = props;
    return (
      <svg viewBox="0 0 24 24" fill="#27A2A8" width={ `${ width }px` } height={ `${ height }px` } ><path d="M18 10v11h-.13c-.44-1.73-2.01-3-3.87-3h-4c-1.86 0-3.43 1.27-3.87 3H6V10c0-3.31 2.69-6 6-6 1.66 0 3.16.67 4.24 1.76A5.944 5.944 0 0 1 18 10z" opacity=".3"/><path d="M17 14.235h2V22h-2zM16.996 9.8C16.89 7.108 14.695 5 12 5S7.11 7.108 7.004 9.799l-1.998-.078C5.154 5.952 8.227 3 12 3s6.846 2.952 6.994 6.722l-1.998.078zM5 14.234h2V22H5z"/><path d="M16 16H8c-2.206 0-4-1.794-4-4s1.794-4 4-4h8c2.206 0 4 1.794 4 4s-1.794 4-4 4zm-8-6c-1.103 0-2 .897-2 2s.897 2 2 2h8c1.103 0 2-.897 2-2s-.897-2-2-2H8z"/><path d="M8 11h2v2H8zM14 11h2v2h-2zM11 0h2v4h-2z"/><path d="M14 5h-4V4a2 2 0 1 1 4 0v1zM19 22h-2c0-1.654-1.346-3-3-3h-4c-1.654 0-3 1.346-3 3H5c0-2.757 2.243-5 5-5h4c2.757 0 5 2.243 5 5z"/></svg>
  );
}

export default Avatar_icn_avatar8;
